const initFilterGenericListingWidget = () => {
    //#region search
    const freeSearchFormArray = document.querySelectorAll("[data-free-search]");
    freeSearchFormArray.forEach(form => {
        form.addEventListener("submit", (e) => {
            e.preventDefault();
            const searchInput = form.querySelector(`input[type="text"]`);
            const url = new URL(`https://${location.host}${location.pathname}${location.search}`);
            url.searchParams.set('src', searchInput.value);
            url.searchParams.delete('startswith');
            location.href = `${url.toString()}#listing`;
        });
    });
    //#endregion
    //#region tab slider
    setTimeout(() => {
        const tabSliderSelector = "[data-filter-tab-slider]";
        const tabSliderArray = document.querySelectorAll(tabSliderSelector);
        if (tabSliderArray && tabSliderArray.length > 0) {
            const config = new CarouselConfig();
            config.sliderSelector = tabSliderSelector;
            config.cellAlign = CellAlign.left;
            config.contain = false;
            config.autoPlay = false;
            config.wrapAround = false;
            config.showArrows = false;
            config.activateCustomButtons = true;
            config.groupCells = false;
            config.adaptiveHeight = false;
            config.imagesLoaded = true;
            const responsiveCarousel = new ResponsiveCarousel();
            responsiveCarousel.initCarousel(config);
        }
    }, 200);
    //#endregion
};
